import * as React from "react";
import { notification } from "antd";
import { useAppDispatch, useAppSelector } from "./store/hooks";
import { selectOrg, setRedirect } from "./store/contextSlice";
import { closeAlert } from "./store/uiDataSlice";

export const GenericAlertContent = () => {
  const dispatch = useAppDispatch();
  const isAlertClosed = useAppSelector((state) => state.uiData.isAlertClosed);
  const alertContent = useAppSelector((state) => state.uiData.alertContent);
  const org = useAppSelector(selectOrg);

  React.useEffect(() => {
    if (isAlertClosed || alertContent === null) {
      return;
    }
    const key = org || "none";
    notification.open({
      key: key,
      type: "warning",
      message: alertContent.title,
      description: (
        <>
          {alertContent.link ? (
            <span
              className="cursor-pointer color-link"
              onClick={() => {
                dispatch(closeAlert());
                notification.destroy(key);
                dispatch(setRedirect(alertContent!.link));
              }}
            >
              Click here
            </span>
          ) : null}
          <span>{alertContent.message}</span>
          <span
            className="block cursor-pointer color-link mt-2"
            onClick={() => {
              localStorage.setItem(alertContent?.id, "true");
              dispatch(closeAlert());
              notification.destroy(key);
            }}
          >
            Do not show again
          </span>
        </>
      ),
      closable: true,
      duration: 10000,
      onClose: () => dispatch(closeAlert()),
      placement: "bottom",
    });

    return () => {
      notification.destroy(key);
    };
  }, [alertContent]);

  return null;
};
